import React from "react";
import { useState, useEffect, useRef } from "react";
import "./index.css";
import { toast_position } from "../../../../redux/features/Settings/Authorization";
import { toast } from "react-toastify";
import {
  addStatementDescription,
  downloadAllOwnerStatement,
  getAllOwnerAccStatement,
  ownerListViewAllAcc,
  resetStatementData,
  setOwnerAllAccStatementLoading,
  updateStatementData,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";

import CommonCalendar from "../../../../components/_utils/CommonCalendar";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";

import IfscCodeMapper from "../../../../components/_utils/IfscLogoMapper";
import OwnerAccountPopUp from "../../../../components/Accounts/OwnerAccountPopUp";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import OwnerDetailsPage from "../OwnerDetailsPage";
import DualIconRoundButton from "../../../../components/_utils/CommonButtons/DualIconRoundButton";
import IconRoundButton from "../../../../components/_utils/CommonButtons/IconRoundButton";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import PrimaryWithIconButton from "../../../../components/_utils/CommonButtons/PrimaryWithIconButton";
import SingleSelectDropDownComponent from "../../../../components/_utils/CommonDropdown/SingleSelectDropdown";
import CommonDownloadFileWithDropdown from "../../../../components/_utils/CommonDownloadFileWithDropdown";
import AmountRangeDropdown from "../../../../components/_utils/CommonDropdown/AmountRangeDropdown";
import PrimaryRightIconFill from "../../../../components/_utils/CommonButtons/PrimaryRightIconFill";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import Chips from "../../../../components/_utils/CommonButtons/Chips";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import { linkIdentifier } from "../../../../utils/linkIdentifier";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import ICONS from "../../../../assets/Icons";
import CommonToast from "../../../../components/_utils/CommonToast";

const OwnerAllStatement = (props) => {
  const amtDivRef = useRef(null);

  const services = useSelector((state) => state.refreshToken.services);
  const navigate = useNavigate();
  const scrollTopRef = useRef(null);
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const [selectStatement, setSelectStatement] = useState(false);
  const [showOwnerPopup, setShowOwnerPopup] = useState(false);
  const [showOwnerDetailPopup, setShowOwnerDetailPopup] = useState(false);
  const [ownerDetailId, setOwnerDetailID] = useState("");
  const [showAmtFilterDiv, setShowAmtFilterDiv] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isAmtFilterApplied, setIsAmtFilterApplied] = useState(false);
  const [isDateConfirm, setIsDateConfirm] = useState(false);
  const {
    ownerAllAccStatementData,
    ownerAllAccStatementLoading,
    ownerAllAccAddDescriptionLoading,
  } = useSelector((state) => state.ownerAllVerification);

  const scrollRef = useRef(null);
  const [filterOpen, setFilterOpen] = useState(false);
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const calenderRef = useRef(null);
  const calenderButtonRef = useRef(null);
  const additionalDetailsRef = useRef(null);
  const additionalDetailsBtnRef = useRef(null);
  const filterButtonRef = useRef(null);
  const selectAccountRef = useRef(null);
  const location = useLocation();
  const [bankOptions, setBankOptions] = useState([]);
  const [pageSize, setPageSize] = useState(dropdownOptions[0]);
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const dispatch = useDispatch();
  const filterRef = useRef(null);
  const filterapplyButtonRef = useRef(null);
  const addtionalapplyButtonRef = useRef(null);
  const calenderapplyButtonRef = useRef(null);
  const [showSelectBank, setShowSelectBank] = useState(false);
  const [selectedtBankState, setSelectedtBankState] = useState("");
  const [selectedtBank, setSelectedtBank] = useState("");
  const [typeOpen, setTypeOpen] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showDescriptionPopup, setShowDescriptionPopup] = useState(false);
  const [description, setDescription] = useState("");

  const [currentDescription, setCurrentDescription] = useState({});

  const [isOpen, setIsOpen] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [source, setSource] = useState("");
  const [sourceState, setSourceState] = useState("");
  const [statementType, setStatementType] = useState("");
  const [statementTypeState, setStatementTypeState] = useState("");
  const [amountLimitState, setAmountLimitState] = useState({
    min: "",
    max: "",
  });
  const [amountLimit, setAmountLimit] = useState({
    min: "",
    max: "",
  });

  const [accountnumberstate, setaccountnumberstate] = useState(
    props?.popType == "ownerStatement" ||
      props?.popType === "remitterBankStatement"
      ? [props?.ownerDetailId]
      : [],
  );
  const [accountNumber, setAccountNumber] = useState(
    props?.popType == "ownerStatement" ||
      props?.popType === "remitterBankStatement"
      ? [props?.ownerDetailId]
      : [],
  );
  const [accountDefaultNumber, setDefaultAccountNumber] = useState(
    props?.popType == "ownerStatement" ||
      props?.popType === "remitterBankStatement"
      ? [props?.ownerDetailId]
      : [],
  );
  const [selectedType, setSelectedType] = useState("XLSX");
  const fileTypeRef = useRef(null);
  const fileTypeRef2 = useRef(null);

  const [startDateState, setStartDateState] = useState(
    new Date(new Date().setDate(1)),
  );
  const [range, setRange] = useState({ min: "", max: "" });
  const [startDate, setStartDate] = useState(new Date(new Date().setDate(1)));
  const [endDateState, setEndDateState] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const defaultAdditionalDetailCol = [
    { colName: "Bank", colWidth: "column-width-sm", flex: 0 },
    {
      colName: "Transaction date and time",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Value date",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Bank reference number",
      colWidth: "column-width-lg",
      flex: 0,
    },
    {
      colName: "Narration",
      colWidth: "column-width-lg",
      flex: 1,
    },
    { colName: "Type", colWidth: "column-width-md", flex: 0 },
    { colName: "Amount", colWidth: "column-width-md", flex: 0 },
    { colName: "Debit amount", colWidth: "column-width-md", flex: 0 },
    { colName: "Credit amount", colWidth: "column-width-md", flex: 0 },
    { colName: "Closing balance", colWidth: "column-width-md", flex: 0 },

    {
      colName: "Account number",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "IFSC code",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Statement source",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Description",
      colWidth: "column-width-lg",
      flex: 1,
    },
  ];

  const [additionalDetailCol, setAdditionalDetailsCol] = useState(
    defaultAdditionalDetailCol,
  );

  const [additionalDetailColState, setAdditionalDetailsColState] = useState(
    defaultAdditionalDetailCol,
  );

  const [isEditDescription, setIsEditDescription] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = await dispatch(ownerListViewAllAcc({}));
        setBankOptions(response?.payload?.summary?.available_banks || []);
      } catch (error) {}
    };

    fetchData();

    return () => {
      dispatch(resetStatementData());
    };
  }, []);

  const columnMapper = {
    "Transaction date and time": "Date and Time",
    "Value date": "Value Date",
    "Bank reference number": "Bank Reference No.",
    "Narration": "Narration",
    "Type": "Type",
    "Amount": "Amount",
    "Debit amount": "Debit Amount",
    "Credit amount": "Credit Amount",
    "Bank": "Bank Name",
    "Account number": "Account Number",
    "IFSC code": "IFSC Code",
    "Closing balance": "Closing Balance",
    "Statement source": "Statement Source",
    "Description": "Description",
  };

  useEffect(() => {
    const handleFetch = () => {
      dispatch(
        getAllOwnerAccStatement({
          id: accountNumber,
          start_date: formatDate(startDate),
          end_date: formatDate(endDate),
          page_no: currentPage,
          credit_debit: statementType,
          start_amount: isAmtFilterApplied ? amountLimit.min : "",
          end_amount: isAmtFilterApplied ? amountLimit.max : "",
          page_size: pageSize,
          entry_source: source.length
            ? source === "Uploaded manually"
              ? true
              : false
            : undefined,
          bank_name: selectedtBank.length ? selectedtBank : undefined,
        }),
      );
    };
    if (accountNumber.length) {
      handleFetch();
    } else {
      dispatch(setOwnerAllAccStatementLoading(false));
    }
  }, [
    currentPage,
    statementType,
    pageSize,
    accountNumber,
    selectedtBank,
    amountLimit,
    startDate,
    endDate,
    source,
  ]);

  const handleApplyEnable = () => {
    if (
      accountDefaultNumber.length &&
      accountnumberstate.length &&
      !accountNumber.length
    ) {
      return true;
    }
    if (
      accountDefaultNumber.length === accountnumberstate.length &&
      accountDefaultNumber.every((ac) => {
        return accountnumberstate.includes(ac);
      }) &&
      accountDefaultNumber.length === accountNumber.length &&
      accountDefaultNumber.every((ac) => {
        return accountNumber.includes(ac);
      }) &&
      !selectedtBank.length &&
      !amountLimit.min.length &&
      !amountLimit.max.length &&
      !statementType.length &&
      !selectedtBankState.length &&
      !isAmtFilterApplied &&
      !sourceState &&
      !statementTypeState.length
    ) {
      return false;
    }
    return true;
  };

  const handleAddDetailaApplyEnable = () => {
    return (
      JSON.stringify(defaultAdditionalDetailCol) !=
        JSON.stringify(additionalDetailColState) ||
      JSON.stringify(defaultAdditionalDetailCol) !=
        JSON.stringify(additionalDetailCol)
    );
  };

  const downloadStatement = async () => {
    UniversalRefreshToast("Downloading statement.");
    setIsDisabled(true);
    try {
      const response = await dispatch(
        downloadAllOwnerStatement({
          id: accountNumber,
          start_date: formatDate(startDate),
          end_date: formatDate(endDate),
          credit_debit: statementType,
          start_amount: isAmtFilterApplied ? amountLimit.min : "",
          end_amount: isAmtFilterApplied ? amountLimit.max : "",
          page_size: pageSize,
          formatType: selectedType.toLowerCase(),
          bank_name: selectedtBank.length ? selectedtBank : undefined,
          entry_source: source.length
            ? source === "Uploaded manually"
              ? true
              : false
            : undefined,
          filter_columns: additionalDetailCol.map(
            (itm) => columnMapper[itm.colName],
          ),
        }),
      );
      toast.dismiss();
      CommonToast({
        text: "Statement downloaded successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      setIsDisabled(false);
      if (!response?.payload?.ok) {
        CommonToast({
          text: response?.payload?.message,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (error) {
      toast.dismiss();
      CommonToast({
        text: "Failed to download statement.",
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setIsDisabled(false);
      console.error(error);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
    }
    if (filterOpen) {
      if (event.key === "Enter" && !showAmtFilterDiv && handleApplyEnable()) {
        filterapplyButtonRef.current.click();
      }
    }
    if (showCalendar) {
      if (
        event.key === "Enter" ||
        (isDateConfirm && startDateState && endDateState)
      ) {
        calenderapplyButtonRef.current.click();
      }
    }
    if (showAdditionalDetails) {
      if (event.key === "Enter" && handleAddDetailaApplyEnable()) {
        addtionalapplyButtonRef.current.click();
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    filterOpen,
    showCalendar,
    showAdditionalDetails,
    showAmtFilterDiv,
    handleAddDetailaApplyEnable,
    handleApplyEnable,
  ]);

  const move = () => {
    scrollRef?.current?.scrollTo({ left: 0, behavior: "smooth" });
    setTimeout(() => {
      scrollTopRef?.current?.scrollTo({ top: 0, behavior: "smooth" });
    }, 500);
  };

  const handleDateChange2 = (dates) => {
    const [start, end] = dates;
    setStartDateState(start);
    setEndDateState(end);

    setIsDateConfirm(true);

    setShowDatePicker(false);
  };

  const handleSelect = (value) => {
    setCurrentPage(1);
    setSelectedValue(value);
    setPageSize(value);
  };

  const handlePagination = (page) => {
    if (scrollRef?.current) {
      scrollRef.current.scrollLeft = GlobalConfiguration.lengthCheckZero;
    }
    setCurrentPage(page);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        (additionalDetailsRef.current &&
          additionalDetailsRef.current.contains(e.target)) ||
        (additionalDetailsBtnRef.current &&
          additionalDetailsBtnRef.current.contains(e.target))
      ) {
      } else {
        setShowAdditionalDetails(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [additionalDetailsRef]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        (filterRef.current && filterRef.current.contains(e.target)) ||
        (filterButtonRef.current &&
          filterButtonRef.current.contains(e.target)) ||
        (selectAccountRef.current &&
          selectAccountRef.current.contains(e.target))
      ) {
      } else {
        setFilterOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [filterRef]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        (calenderRef.current && calenderRef.current.contains(e.target)) ||
        (calenderButtonRef.current &&
          calenderButtonRef.current.contains(e.target))
      ) {
      } else {
        setShowCalendar(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [calenderRef]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (fileTypeRef.current && fileTypeRef.current.contains(e.target)) {
      } else if (
        fileTypeRef2.current &&
        fileTypeRef2.current.contains(e.target)
      ) {
      } else {
        setSelectStatement(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [fileTypeRef, fileTypeRef2]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (amtDivRef.current && amtDivRef.current.contains(e.target)) {
      } else {
        setShowAmtFilterDiv(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [amtDivRef]);

  const handleAddDetail = (name) => {
    if (!additionalDetailColState.some((x) => x.colName === name)) {
      let data = {
        colName: name,
        colWidth: defaultAdditionalDetailCol.find((x) => x.colName === name)
          .colWidth,
        flex: defaultAdditionalDetailCol.find((x) => x.colName === name).flex,
      };
      let arr = [...additionalDetailColState, data].sort(
        (a, b) =>
          defaultAdditionalDetailCol.map((x) => x.colName).indexOf(a.colName) -
          defaultAdditionalDetailCol.map((x) => x.colName).indexOf(b.colName),
      );
      setAdditionalDetailsColState(arr);
    } else {
      if (additionalDetailColState.length === 1) {
        return CommonToast({
          text: "Atleast one column is required",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      setAdditionalDetailsColState(
        additionalDetailColState
          .filter((itm) => {
            return name !== itm.colName;
          })
          .sort(
            (a, b) =>
              defaultAdditionalDetailCol
                .map((x) => x.colName)
                .indexOf(a.colName) -
              defaultAdditionalDetailCol
                .map((x) => x.colName)
                .indexOf(b.colName),
          ),
      );
    }
  };

  const formatDateandTime = (date, showtime) => {
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();

    const ampm = hours >= 12 ? "pm" : "am";
    hours %= 12;
    hours = hours || 12;

    if (showtime) {
      return `${date.getUTCDate()}-${date.getUTCMonth() + 1}-${date.getUTCFullYear()}, ${
        hours < 10 ? "0" + hours : hours
      }:${minutes < 10 ? "0" + minutes : minutes} ${ampm}`;
    } else {
      return `${date.getUTCDate()}-${date.getUTCMonth() + 1}-${date.getUTCFullYear()}`;
    }
  };
  const formatDate = (date) => {
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();

    return `${day} ${month}, ${year}`;
  };

  // const formatDateandTime = (date, showtime) => {
  //   let hours = date.getUTCHours();
  //   const minutes = date.getUTCMinutes();

  //   const ampm = hours >= 12 ? "pm" : "am";
  //   hours %= 12;
  //   hours = hours || 12;

  //   if (showtime) {
  //     return `${date.getUTCDate()}-${date.getUTCMonth() + 1}-${date.getUTCFullYear()}, ${
  //       hours < 10 ? "0" + hours : hours
  //     }:${minutes < 10 ? "0" + minutes : minutes} ${ampm}`;
  //   } else {
  //     return `${date.getUTCDate()}-${date.getUTCMonth() + 1}-${date.getUTCFullYear()}`;
  //   }
  // };

  const filterCategory = () => {
    move();
    setCurrentPage(1);
    setStartDate(startDateState);
    setEndDate(endDateState);
    setShowDatePicker(false);
    setShowCalendar(false);
  };

  const formatAmount = (value) => {
    if (!value) return "";
    return Number(value).toLocaleString("en-IN");
  };

  const handleAmtFilterApply = () => {
    if (
      amountLimitState.min === "" ||
      amountLimitState.max === "" ||
      Number(amountLimitState.min) >= Number(amountLimitState.max)
    )
      return;
    setIsAmtFilterApplied(true);
    setTimeout(() => {
      setShowAmtFilterDiv(false);
    }, 500);
  };

  const handleClearAmts = () => {
    setAmountLimitState((prev) => ({
      ...prev,
      min: "",
      max: "",
    }));
    setIsAmtFilterApplied(false);
  };

  const handleKey = (event) => {
    if (showAmtFilterDiv) {
      if (event.key === "Enter" && showAmtFilterDiv && isAmtFilterApplied) {
        handleAmtFilterApply();
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("keydown", handleKey);
    };
  }, [isAmtFilterApplied, showAmtFilterDiv]);

  const handleEnterKey = (e) => {
    if (
      amountLimitState.min !== "" &&
      amountLimitState.max !== "" &&
      Number(amountLimitState.max) >= Number(amountLimitState.min) &&
      e.key === "Enter"
    ) {
      handleAmtFilterApply();
    }
  };

  return (
    <>
      {showDescriptionPopup && (
        <div
          style={{ zIndex: "var(--z-index-modal)" }}
          className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center bg-opacity-dark-opacity"
        >
          <SmallPopupWithInput
            headerTitle="Description"
            headerFontColor="text-primary"
            headerFontWeight="semibold"
            textSize="font-md"
            subtext="Provide custom description for easier tracking and reconciliation"
            inputIsFullWidth={true}
            inputBgColor="var(--primary-bg)"
            inputPlaceholder="Enter description (upto 150 char)"
            inputFgColor={
              description?.length
                ? "var(--text-primary)"
                : "var(--text-secondary)"
            }
            inputValue={description}
            inputFontKind="medium"
            inputOnInput={(e) => {
              if (
                e.target.value?.replace(/\s+/g, " ").trimStart()?.length <=
                GlobalConfiguration.inputMaxLength
              )
                setDescription(
                  e.target.value?.replace(/\s+/g, " ").trimStart(),
                );
            }}
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneHandleFunction={() => {
              if (!ownerAllAccAddDescriptionLoading) {
                setShowDescriptionPopup(false);
                setDescription("");
                setCurrentDescription({});
              }
            }}
            btnOneEnabledBgColor="transparent"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={ownerAllAccAddDescriptionLoading}
            btnOneHoverOption="white"
            btnTwoText={
              currentDescription?.description?.length ? "Confirm" : "Add"
            }
            btnTwoBtnType="button"
            btnTwoHandleFunction={async () => {
              if (!ownerAllAccAddDescriptionLoading) {
                let response = await dispatch(
                  addStatementDescription({
                    id: currentDescription.acc_id,
                    statement_entry_id:
                      currentDescription.account_statement_entry_id,
                    description: description,
                  }),
                );

                if (response?.payload?.status) {
                  dispatch(
                    updateStatementData({
                      description,
                      account_statement_entry_id:
                        currentDescription.account_statement_entry_id,
                    }),
                  );
                }

                setCurrentDescription({});
                setShowDescriptionPopup(false);
                setDescription("");
                setIsEditDescription(false);
              }
            }}
            btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoDisabledTextColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              (!isEditDescription && !description?.length) ||
              description === currentDescription?.description
            }
            btnTwoIsLoading={ownerAllAccAddDescriptionLoading}
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}
      {showConfirmPopup && (
        <div
          style={{ zIndex: "var(--z-index-modal)" }}
          className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center bg-opacity-dark-opacity"
        >
          <SmallPopup
            headerTitle="Proceed to upload statement?"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext="Leaving this page will exit you from current flow."
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneHandleFunction={() => setShowConfirmPopup(false)}
            btnOneEnabledBgColor="transparent"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoBtnType="button"
            btnTwoHandleFunction={() =>
              navigate("/owner_account_dashboard/upload_bulk_bank_statement", {
                state: {
                  ownerBankAccountNo: props?.ownerDetailData?.bank_acc_no,
                  ownerBankIFSC: props?.ownerDetailData?.ifsc_code,
                  ownerBankLogo: props?.ownerDetailData?.ifsc_code,
                  bank_name: props?.ownerDetailData?.bank_name,
                  ownerBankAccountName: props?.ownerDetailData?.bank_name,
                },
              })
            }
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {showOwnerDetailPopup && (
        <LargePopupRedirect
          headerTitle="Owner account details"
          closeiconhandleFunction={() => setShowOwnerDetailPopup(false)}
        >
          <OwnerDetailsPage
            onClosed={() => setShowOwnerDetailPopup(false)}
            popType={"ownerStatement"}
            ownerDetailId={ownerDetailId}
          />
        </LargePopupRedirect>
      )}
      {showOwnerPopup && (
        <div
          style={{ zIndex: "var(--z-index-modal)" }}
          className="fixed top-top-base left-left-base w-width-full h-height-full bg-Primary-black bg-opacity-light-opacity"
        >
          <OwnerAccountPopUp
            setIsSidebarOpen={filterOpen}
            setOpenOwner={() => {
              setaccountnumberstate(accountNumber);
              setShowOwnerPopup(false);
            }}
            onClosed={() => setShowOwnerPopup(false)}
            accountNumber={accountNumber}
            setAccountNumber={setAccountNumber}
            accountnumberstate={accountnumberstate}
            setaccountnumberstate={setaccountnumberstate}
            multiSelect={true}
            setDefaultAccountNumber={setDefaultAccountNumber}
            accountDefaultNumber={accountDefaultNumber}
            flow={"txnViewAll"}
            popType={"ownerStatement"}
          />
        </div>
      )}
      {
        <div
          style={{
            display: !ownerAllAccStatementData?.statement?.length && "none",
            background: !ownerAllAccStatementData?.statement?.length
              ? "var(--primary-bg)"
              : "var(--primary-nav)",
            zIndex:
              showCalendar || filterOpen || showAdditionalDetails
                ? "var(--z-index-base)"
                : "var(--z-index-fixed-ui)",
            width:
              props?.popType == "ownerStatement" ||
              props?.popType === "remitterBankStatement"
                ? "var(--popup-width)"
                : "var(--width-full)",
            bottom:
              props?.popType == "ownerStatement" ||
              props?.popType === "remitterBankStatement"
                ? "var(--bottom-sm)"
                : "var(--bottom-base)",
            borderRadius:
              props?.popType == "ownerStatement" ||
              props?.popType === "remitterBankStatement"
                ? " var(--border-radius-md)"
                : "none",
          }}
          className={`fixed w-width-full  ${
            props?.popType == "ownerStatement" ||
            props?.popType === "remitterBankStatement"
              ? "ownerdetailsresponsivestatement"
              : ""
          }`}
        >
          <PaginationComponent
            handleSelect={handleSelect}
            selectedValue={selectedValue}
            data={ownerAllAccStatementData || []}
            pageSize={pageSize}
            dropdownOptions={dropdownOptions}
            handlePagination={handlePagination}
            currentPage={currentPage}
            setIsOpen={setIsOpen}
            typePopup={props?.popType == "ownerStatement" ? true : false}
          />
        </div>
      }

      <div
        className={` bg-primary-bg flex flex-col ${
          props?.popType === "remitterBankStatement" && "h-full"
        }  overflow-hidden ${
          props?.popType === "ownerStatement" ||
          props?.popType === "remitterBankStatement"
            ? " flex-1"
            : "h-full-height"
        }`}
        style={{ overflow: filterOpen && "hidden" }}
      >
        <div
          className={`hidden ${
            props?.popType == "ownerStatement" ||
            props?.popType === "remitterBankStatement"
              ? "hidden"
              : "Qsmd:block"
          } `}
          style={{
            minHeight:
              props?.popType == "ownerStatement" ||
              props?.popType === "remitterBankStatement"
                ? "var(--navbar-height)"
                : "var(--navbar-breadcrumb-height)",
            backgroundColor: "var(--primary-nav)",
            zIndex: "var(--z-index-header)",
          }}
        ></div>
        <div
          className={`${
            props?.popType == "ownerStatement" ||
            props?.popType === "remitterBankStatement"
              ? "OAS-owner_div_container-popup"
              : "OAS-owner_div_container"
          }`}
        >
          <div className={"OAS-owner_div  px-padding-sm py-padding-sm "}>
            <div className=" flex flex-wrap Qsmd:justify-between w-width-full gap-y-gap-sm">
              <div
                className="flex Total_Value_Responsives"
                style={{
                  position: "relative",
                }}
              >
                <div
                  className=" py-padding-md px-padding-sm cursor-pointer flex Qsmd:hidden"
                  onClick={() => {
                    if (
                      props?.popType == "ownerStatement" ||
                      props?.popType === "remitterBankStatement"
                    ) {
                      props?.setViewstatementOpenPop(false);
                    } else {
                      navigate(-1);
                    }
                  }}
                >
                  <SVGComponent
                    color={"var(--text-primary)"}
                    height="var(--icon-sm)"
                    width="var(--icon-sm)"
                    url={
                      "https://q2pay.in/new_assets/common/arrows/arrow_left_white.svg"
                    }
                    alt="Icon"
                  />
                </div>
                <div className="flex flex-col gap-gap-xs">
                  <p className="text-font-sm text-text-primary">
                    Total entries : {ownerAllAccStatementData?.total_count || 0}
                  </p>
                  <p className="text-font-xxs text-text-secondary  ">
                    As on {formatDate(new Date())} - Statement update depends on
                    availability from the bank
                  </p>
                </div>
              </div>

              <div className="gap-gap-sm lg:border-l-border border-primary-bg pl-padding-lg  Qsmd:pl-padding-md gap-y-gap-sm  py-padding-xs flex flex-wrap Qsmd:justify-between items-center relative">
                <DualIconRoundButton
                  icon={
                    "https://q2pay.in/new_assets/common/view_all/calender.svg"
                  }
                  imgColor={"var(--primary-bg)"}
                  arrowIconDown={
                    "https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg"
                  }
                  arrowIconUP={
                    "https://q2pay.in/new_assets/common/arrows/arrow_up_white.svg"
                  }
                  arrowIconUPColor="var(--primary-bg)"
                  arrowIconDownColor="var(--primary-bg)"
                  handleFunction={() => {
                    if (!showAdditionalDetails && !filterOpen)
                      setShowCalendar(!showCalendar);
                  }}
                  isLoading={false}
                  isOpen={showCalendar}
                  isDisabled={showAdditionalDetails || filterOpen}
                  enabledBgColor={"var(--text-primary)"}
                  disabledBgColor={"var(--text-primary)"}
                  buttonRef={calenderButtonRef}
                  title="Open Calendar"
                />
                <DualIconRoundButton
                  icon={
                    "https://q2pay.in/new_assets/common/view_all/additional_fields_white.svg"
                  }
                  imgColor={"var(--primary-bg)"}
                  arrowIconDown={
                    "https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg"
                  }
                  arrowIconUP={
                    "https://q2pay.in/new_assets/common/arrows/arrow_up_white.svg"
                  }
                  arrowIconUPColor="var(--primary-bg)"
                  arrowIconDownColor="var(--primary-bg)"
                  handleFunction={() => {
                    if (
                      !showCalendar &&
                      !filterOpen &&
                      accountDefaultNumber.length
                    ) {
                      setShowAdditionalDetails(!showAdditionalDetails); // Toggle visibility
                    }
                  }}
                  isLoading={false}
                  isOpen={showAdditionalDetails}
                  isDisabled={
                    showCalendar || filterOpen || !accountDefaultNumber.length
                  }
                  enabledBgColor={"var(--text-primary)"}
                  disabledBgColor={"var(--text-primary)"}
                  buttonRef={additionalDetailsBtnRef}
                  title="Additional Fields"
                />
                <DualIconRoundButton
                  icon={
                    "https://q2pay.in/new_assets/common/view_all/filter.svg"
                  }
                  imgColor={
                    accountNumber.length ||
                    statementType.length ||
                    selectedtBank.length ||
                    (amountLimit.max.length && amountLimit.max.length)
                      ? "var(--primary-bg)"
                      : "var(--text-primary)"
                  }
                  arrowIconDown={
                    "https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg"
                  }
                  arrowIconDownColor={
                    accountNumber.length ||
                    statementType.length ||
                    selectedtBank.length ||
                    (amountLimit.max.length && amountLimit.max.length)
                      ? "var(--primary-bg)"
                      : "var(--text-primary)"
                  }
                  arrowIconUP={
                    "https://q2pay.in/new_assets/common/arrows/arrow_up_white.svg"
                  }
                  arrowIconUPColor={
                    (filterOpen && accountNumber.length) ||
                    statementType.length ||
                    selectedtBank.length ||
                    (amountLimit.max.length && amountLimit.max.length)
                      ? "var(--primary-bg)"
                      : "var(--text-primary)"
                  }
                  handleFunction={() => {
                    if (
                      !showAdditionalDetails &&
                      !showCalendar &&
                      accountDefaultNumber.length
                    ) {
                      setFilterOpen(!filterOpen);
                    }
                  }}
                  isLoading={false}
                  isOpen={filterOpen}
                  isDisabled={
                    showAdditionalDetails ||
                    showCalendar ||
                    !accountDefaultNumber.length
                  }
                  enabledBgColor={"var(--text-primary)"}
                  disabledBgColor={
                    accountNumber.length ||
                    statementType.length ||
                    selectedtBank.length ||
                    (amountLimit.max.length && amountLimit.max.length)
                      ? "var(--text-primary)"
                      : "var(--primary-bg)"
                  }
                  buttonRef={filterButtonRef}
                  title="Filters"
                />
                <IconRoundButton
                  enabledBgColor="var(--primary-bg)"
                  isLoading={false}
                  isDisabled={
                    showAdditionalDetails || filterOpen || showCalendar
                  }
                  handleFunction={() => {
                    if (!showAdditionalDetails && !filterOpen && !showCalendar)
                      setShowConfirmPopup(true);
                  }}
                  icon={
                    "https://q2pay.in/new_assets/common/view_all/upload.svg"
                  }
                  title="Upload statement"
                  imgColor="var(--text-primary)"
                />
                <div className=" pl-padding-base Qsmd:pl-padding-sm">
                  <CommonDownloadFileWithDropdown
                    btnText="Download statement"
                    dropdownOptions={["XLSX", "CSV", "TSV", "PDF"]}
                    icon={
                      "https://q2pay.in/new_assets/common/view_all/download_statement.svg"
                    }
                    isDisabled={
                      isDisabled ||
                      showAdditionalDetails ||
                      filterOpen ||
                      showCalendar ||
                      !ownerAllAccStatementData?.statement ||
                      !selectedType
                    }
                    handleFunction={(e) => {
                      if (
                        showAdditionalDetails ||
                        !selectedType ||
                        filterOpen ||
                        showCalendar ||
                        !ownerAllAccStatementData?.statement ||
                        isDisabled
                      ) {
                        e.stopPropagation();
                        return;
                      } else {
                        downloadStatement();
                      }
                    }}
                    selectedOption={selectedType}
                    setSelectedOption={setSelectedType}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className={`OAS-filter-transition-${filterOpen ? "open" : "close"}`}
          >
            <div
              style={{
                maxWidth: "var(--max-content-width)",
                margin: "var(--margin-base) auto",
                borderTop: "var(--border) solid var(--primary-bg)",
                padding: "var(--padding-md) var(--padding-sm)",
              }}
              ref={filterRef}
            >
              <span className="text-text-primary font-normal  text-font-sm">
                Filter{" "}
              </span>
              <div className="OAS-owner_filterdropdown">
                <div
                  className="w-width-full Qsmd:w-width-md p-padding-base Qsmd:pr-padding-md"
                  style={{
                    paddingTop: "var(--padding-md)",
                    display: "flex",
                    flexDirection: "column",
                    gap: "var(--gap-md)",
                    height: "fit-content",
                  }}
                >
                  <div style={{ position: "relative" }}>
                    <p
                      style={{
                        color: "var(--text-secondary)",
                        fontSize: "var(--font-xs)",
                        marginBottom: "var(--margin-xs)",
                      }}
                    >
                      Account
                    </p>
                    <PrimaryRightIconFill
                      btnText={
                        props?.popType == "ownerStatement" ||
                        props?.popType === "remitterBankStatement"
                          ? formatAccountNumber(
                              props?.ownerDetailData?.bank_acc_no,
                            )
                          : accountnumberstate.length
                            ? `${accountnumberstate.length} selected`
                            : "Select accounts"
                      }
                      btnType="button"
                      handleFunction={() => {
                        if (props?.popType != "ownerStatement") {
                          setShowOwnerPopup(true);
                        }
                      }}
                      isDisabled={props?.popType == "ownerStatement"}
                      enabledBgColor="var(--primary-act)"
                      disabledBgColor="var(--primary-act)"
                      enabledTextColor="var(--text-primary)"
                      disabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                      }
                      imgColor="var(--text-primary)"
                      hoverOption="white"
                      buttonRef={selectAccountRef}
                    />
                  </div>

                  <div>
                    <p
                      style={{
                        color: "var(--text-secondary)",
                        fontSize: "var(--font-xs)",
                        marginBottom: "var(--margin-xs)",
                      }}
                    >
                      Type
                    </p>
                    <div>
                      <SingleSelectDropDownComponent
                        type="small"
                        options={["Credit", "Debit"]}
                        selected={statementTypeState}
                        setSelected={setStatementTypeState}
                        showSearch={false}
                        isOpen={typeOpen}
                        placeholder="Select type"
                      />
                    </div>
                  </div>
                </div>
                <div className="OAS-owner-border-div-line"></div>
                <div
                  className="w-width-full Qsmd:w-width-md pr-padding-base pl-padding-base Qsmd:pr-padding-base Qsmd:pl-padding-md"
                  style={{
                    paddingTop: "var(--padding-md)",
                    display: "flex",
                    flexDirection: "column",
                    gap: "var(--gap-md)",
                    height: "fit-content",
                  }}
                >
                  <div>
                    <p
                      style={{
                        color: "var(--text-secondary)",
                        fontSize: "var(--font-xs)",
                        marginBottom: "var(--margin-xs)",
                      }}
                    >
                      Amount
                    </p>
                    <AmountRangeDropdown
                      placeholder="Set amount range"
                      type="small"
                      range={amountLimitState}
                      setRange={setAmountLimitState}
                      onOpen={() => setShowAmtFilterDiv(true)}
                      onClose={() => setShowAmtFilterDiv(false)}
                      onApply={(range) => {
                        setIsAmtFilterApplied(true);
                      }}
                      onClear={() => {
                        handleClearAmts();
                      }}
                    />
                  </div>
                  <div>
                    <p
                      style={{
                        color: "var(--text-secondary)",
                        fontSize: "var(--font-xs)",
                        marginBottom: "var(--margin-xs)",
                      }}
                    >
                      Statement source
                    </p>
                    <div>
                      <SingleSelectDropDownComponent
                        type="small"
                        options={["Uploaded manually", "Fetch from bank"]}
                        selected={sourceState}
                        setSelected={setSourceState}
                        showSearch={false}
                        placeholder="Select statement source"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="mb-margin-base Qsmd:mb-margin-base Qsmd:pt-padding-md Qsmd:pb-padding-md rounded-tl-border-radius-md  rounded-tr-border-radius-md px-padding-sm mt-margin-md Qsmd:mt-margin-base Qsmd:px-padding-base  items-center justify-end  relative bottom-bottom-base w-width-full  Qsmd:h-0 Qsmd:bg-transparent "
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div className="OAS-buttoncontainer">
                  <PrimaryButton
                    isDisabled={!handleApplyEnable()}
                    enabledBgColor=""
                    btnText="Default"
                    outLineColor="var(--text-primary)"
                    enabledTextColor="var(--text-primary)"
                    handleFunction={() => {
                      if (handleApplyEnable()) {
                        move();
                        setAccountNumber(accountDefaultNumber);
                        setaccountnumberstate(accountDefaultNumber);
                        setSelectedtBank("");
                        setSelectedtBankState("");
                        setSource("");
                        setSourceState("");
                        setAmountLimit({ min: "", max: "" });
                        setAmountLimitState({ min: "", max: "" });
                        setStatementType("");
                        setStatementTypeState("");
                        setIsAmtFilterApplied(false);
                        setCurrentPage(1);
                      }
                    }}
                    hoverOption="white"
                  />

                  <PrimaryButton
                    isDisabled={!handleApplyEnable()}
                    enabledTextColor="var(--primary-bg)"
                    enabledBgColor="var(--text-primary)"
                    btnText="Apply"
                    inActiveVariantNeeded={true}
                    disabledTextColor={"var(--text-primary)"}
                    disabledBgColor={"var(--text-disabled)"}
                    handleFunction={() => {
                      if (handleApplyEnable()) {
                        move();
                        setAccountNumber(accountnumberstate);
                        setSelectedtBank(selectedtBankState);
                        if (
                          isAmtFilterApplied &&
                          amountLimitState.min !== "" &&
                          amountLimitState.max !== "" &&
                          Number(amountLimitState.max) >
                            Number(amountLimitState.min)
                        ) {
                          setAmountLimit(amountLimitState);
                        } else if (
                          !amountLimitState.min.length ||
                          !amountLimitState.max.length
                        ) {
                          setAmountLimit(amountLimitState);
                        }
                        setStatementType(statementTypeState);
                        setSource(sourceState);
                        setCurrentPage(1);
                        setFilterOpen(false);
                      }
                    }}
                    hoverOption={handleApplyEnable() ? "black" : "white"}
                    buttonRef={filterapplyButtonRef}
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            ref={calenderRef}
            className={`OAS-filter-transition-${showCalendar ? "open" : "close"}`}
          >
            <div
              className="OAS-beneTxnviewallFilterDiv flex justify-between"
              style={{
                borderTop: "var(--border) solid var(--primary-bg)",
              }}
            >
              <div className="OAS-beneTxnFilterSection1">
                <span className="text-text-primary font-normal text-font-sm">
                  Calender{" "}
                </span>
                <div className="OAS-beneTxnFilterSection3 mt-margin-md">
                  <span
                    style={{
                      color: "var(--text-secondary)",
                      width: "var(--width-full)",
                      height: "fit-content",
                      fontSize: "var(--font-xs)",
                      fontWeight: "var(--font-normal)",
                      marginBottom: "var(--margin-xs)",
                    }}
                  >
                    Date range
                  </span>

                  <div className="pt-padding-base Qmd:pt-padding-sm flex flex-1 ">
                    <CommonCalendar
                      startDate={startDateState}
                      endDate={endDateState}
                      handleDateChange={handleDateChange2}
                      type="small"
                      selectionType="range"
                    />
                  </div>
                </div>
              </div>
              <div
                className=" mb-margin-base Qsmd:mb-margin-base  rounded-tl-border-radius-md  rounded-tr-border-radius-md px-padding-sm mt-margin-md Qsmd:px-padding-base  items-center justify-end  relative bottom-bottom-base w-width-full  Qsmd:bg-transparent Qsmd:pt-padding-base pt-padding-sm "
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div className="OAS-buttoncontainer">
                  <PrimaryButton
                    isDisabled={
                      !(
                        (+startDate !== +startDateState &&
                          +endDate !== +endDateState) ||
                        !startDate ||
                        !endDate ||
                        isDateConfirm
                      )
                    }
                    enabledBgColor=""
                    btnText="Default"
                    disabledTextColor={""}
                    disabledBgColor={""}
                    outLineColor="var(--text-primary)"
                    enabledTextColor="var(--text-primary)"
                    handleFunction={() => {
                      if (
                        (+startDate !== +startDateState &&
                          +endDate !== +endDateState) ||
                        !startDate ||
                        !endDate ||
                        isDateConfirm
                      ) {
                        move();
                        setStartDate(new Date(new Date().setDate(1)));
                        setStartDateState(new Date(new Date().setDate(1)));
                        setEndDate(new Date());
                        setEndDateState(new Date());
                        setIsDateConfirm(false);
                      }
                    }}
                    hoverOption="white"
                  />

                  <PrimaryButton
                    isDisabled={
                      !(isDateConfirm && startDateState && endDateState)
                    }
                    inActiveVariantNeeded={true}
                    enabledBgColor="var(--text-primary)"
                    btnText="Apply"
                    enabledTextColor="var(--primary-bg)"
                    handleFunction={() => {
                      if (isDateConfirm && startDateState && endDateState) {
                        filterCategory();
                      }
                    }}
                    hoverOption={
                      !(isDateConfirm && startDateState && endDateState)
                        ? "white"
                        : "black"
                    }
                    buttonRef={calenderapplyButtonRef}
                    disabledTextColor={"var(--text-primary)"}
                    disabledBgColor={"var(--text-disabled)"}
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            ref={additionalDetailsRef}
            className={`OAS-filter-transition-${showAdditionalDetails ? "open" : "close"} overflow-auto`}
          >
            <div
              className="OAS-beneTxnviewallFilterDiv h-full-height Qsmd:h-auto flex justify-start  Qsmd:justify-between"
              style={{
                borderTop: "var(--border) solid var(--primary-bg)",
              }}
            >
              <div className=" pb-padding-md Qsmd:pb-padding-base oas-addtional-div Qsmd:h-auto px-padding-md Qsmd:px-padding-base">
                <span className="text-text-primary font-normal  text-font-sm">
                  Additional Fields{" "}
                </span>
                <div className=" Qsmd:flex justify-between text-font-xs text-text-secondary gap-gap-md">
                  <div className="flex flex-col gap-gap-md mt-margin-md w-width-full Qsmd:w-width-sm">
                    <PrimaryRightIconFill
                      btnText="Bank"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Bank");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Bank",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Bank",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Bank",
                        )
                          ? "black"
                          : "white"
                      }
                    />

                    <PrimaryRightIconFill
                      btnText="Bank reference number"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Bank reference number");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Bank reference number",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Bank reference number",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Bank reference number",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                    <PrimaryRightIconFill
                      btnText="Debit amount"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Debit amount");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Debit amount",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Debit amount",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Debit amount",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                    <PrimaryRightIconFill
                      btnText="Statement source"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Statement source");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Statement source",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Statement source",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Statement source",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                  </div>
                  <div className="OAS-border-mid-div"></div>
                  <div className="flex flex-col gap-gap-md mt-margin-md w-width-full Qsmd:w-width-sm">
                    <PrimaryRightIconFill
                      btnText="Account number"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Account number");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Account number",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Account number",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Account number",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                    <PrimaryRightIconFill
                      btnText="Narration"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Narration");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Narration",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Narration",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Narration",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                    <PrimaryRightIconFill
                      btnText="Credit amount"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Credit amount");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Credit amount",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Credit amount",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Credit amount",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                    <PrimaryRightIconFill
                      btnText="Description"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Description");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Description",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Description",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Description",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                  </div>
                  <div className="OAS-border-mid-div"></div>
                  <div className="flex flex-col gap-gap-md mt-margin-md w-width-full Qsmd:w-width-sm">
                    <PrimaryRightIconFill
                      btnText="Transaction date and time"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Transaction date and time");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Transaction date and time",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Transaction date and time",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Transaction date and time",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                    <PrimaryRightIconFill
                      btnText="Type"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Type");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Type",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Type",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Type",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                    <PrimaryRightIconFill
                      btnText="Closing balance"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Closing balance");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Closing balance",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Closing balance",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Closing balance",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                  </div>
                  <div className="OAS-border-mid-div"></div>
                  <div className="flex flex-col gap-gap-md mt-margin-md w-width-full Qsmd:w-width-sm">
                    <PrimaryRightIconFill
                      btnText="Value date"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Value date");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Value date",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Value date",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Value date",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                    <PrimaryRightIconFill
                      btnText="Amount"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("Amount");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "Amount",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "Amount",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "Amount",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                    <PrimaryRightIconFill
                      btnText="IFSC code"
                      btnType="button"
                      handleFunction={() => {
                        handleAddDetail("IFSC code");
                      }}
                      enabledBgColor={
                        additionalDetailColState.some(
                          (x) => x.colName === "IFSC code",
                        )
                          ? "var(--positive-bg)"
                          : "var(--primary-act)"
                      }
                      enabledTextColor="var(--text-primary)"
                      isLoading={false}
                      icon={
                        additionalDetailColState.some(
                          (x) => x.colName === "IFSC code",
                        )
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }
                      hoverOption={
                        additionalDetailColState.some(
                          (x) => x.colName === "IFSC code",
                        )
                          ? "black"
                          : "white"
                      }
                    />
                  </div>
                </div>
              </div>
              <div
                className="py-padding-lg mb-margin-base Qsmd:mb-margin-base Qsmd:pb-padding-md rounded-tl-border-radius-md  rounded-tr-border-radius-md px-padding-sm mt-margin-base Qsmd:mt-margin-base Qsmd:px-padding-base  items-center justify-end relative bottom-bottom-base w-width-full  Qsmd:h-0 Qsmd:bg-transparent "
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div className="OAS-buttoncontainer">
                  <PrimaryButton
                    isDisabled={!handleAddDetailaApplyEnable()}
                    enabledBgColor=""
                    btnText="Default"
                    outLineColor="var(--text-primary)"
                    enabledTextColor="var(--text-primary)"
                    handleFunction={() => {
                      if (handleAddDetailaApplyEnable()) {
                        move();
                        setAdditionalDetailsColState(
                          defaultAdditionalDetailCol,
                        );
                        setAdditionalDetailsCol(defaultAdditionalDetailCol);
                      }
                    }}
                    hoverOption="white"
                  />

                  <PrimaryButton
                    isDisabled={!handleAddDetailaApplyEnable()}
                    enabledBgColor="var(--text-primary)"
                    btnText="Apply"
                    enabledTextColor="var(--primary-bg)"
                    inActiveVariantNeeded={true}
                    handleFunction={() => {
                      if (handleAddDetailaApplyEnable()) {
                        move();
                        setAdditionalDetailsCol(additionalDetailColState);
                        setShowAdditionalDetails(false);
                      }
                    }}
                    hoverOption={
                      handleAddDetailaApplyEnable() ? "black" : "white"
                    }
                    buttonRef={addtionalapplyButtonRef}
                    disabledTextColor={"var(--text-primary)"}
                    disabledBgColor={"var(--text-disabled)"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`${
            props?.popType == "ownerStatement" ||
            props?.popType === "remitterBankStatement"
              ? "OAS-filter_applied_div_owner_detail"
              : ""
          } OAS-filter_applied_div w-width-full`}
        >
          <div
            style={{
              borderTop: "var(--border) solid var(--primary-bg)",
            }}
            className={` Qsmd:w-max-content-width mx-auto py-padding-sm  pl-padding-sm flex justify-between items-center  Qsmd:relative ${
              showCalendar || showAdditionalDetails || filterOpen
                ? ""
                : "z-z-index-content"
            } Qsmd:z-z-index-base  Qsmd:mt-top-base overflow-x-auto Qsmd:overscroll-none bg-primary-nav Qsmd:bg-transparent`}
          >
            <div className="flex w-full-width">
              <div className="filter_badge_div oas-filter_badge_div_responsive">
                {startDate && endDate && (
                  <Chips
                    txtChip={`${formatDate(startDate).replace(
                      ",",
                      "",
                    )} - ${formatDate(endDate).replace(",", "")}`}
                    icon={
                      "https://q2pay.in/new_assets/common/view_all/close_with_blue_circle.svg"
                    }
                    enabledBgColor=""
                    outLineColor="var(--primary-act)"
                    disableIcon={true}
                    handleFunction={(e) => {
                      e.stopPropagation();
                      return;
                    }}
                    enabledTextColor="var(--text-primary)"
                  />
                )}
                {accountNumber.length > 0 && (
                  <Chips
                    txtChip={
                      props?.popType == "ownerStatement" ||
                      props?.popType === "remitterBankStatement"
                        ? formatAccountNumber(
                            props?.ownerDetailData?.bank_acc_no,
                          )
                        : `${accountNumber.length} ${
                            accountNumber.length > 1
                              ? "accounts selected"
                              : "account selected"
                          }`
                    }
                    icon={
                      "https://q2pay.in/new_assets/common/view_all/close_with_blue_circle.svg"
                    }
                    enabledBgColor=""
                    outLineColor="var(--primary-act)"
                    disableIcon={true}
                    handleFunction={(e) => {
                      e.stopPropagation();
                      return;
                    }}
                    enabledTextColor="var(--text-primary)"
                  />
                )}
                {selectedtBank.length > 0 && (
                  <Chips
                    txtChip={selectedtBank}
                    icon={
                      "https://q2pay.in/new_assets/common/view_all/close_with_blue_circle.svg"
                    }
                    enabledBgColor=""
                    outLineColor="var(--primary-act)"
                    disableIcon={false}
                    handleFunction={() => {
                      setSelectedtBank("");
                      setSelectedtBankState("");
                    }}
                    hoverOption="white"
                    enabledTextColor="var(--text-primary)"
                  />
                )}
                {statementType.length > 0 && (
                  <Chips
                    txtChip={statementType}
                    icon={
                      "https://q2pay.in/new_assets/common/view_all/close_with_blue_circle.svg"
                    }
                    enabledBgColor=""
                    outLineColor="var(--primary-act)"
                    disableIcon={false}
                    handleFunction={() => {
                      setStatementType("");
                      setStatementTypeState("");
                    }}
                    hoverOption="white"
                    enabledTextColor="var(--text-primary)"
                  />
                )}
                {amountLimit.min.length > 0 && amountLimit.max.length > 0 && (
                  <Chips
                    txtChip={`INR ${formatAmount(amountLimit.min)} - INR ${formatAmount(amountLimit.max)}`}
                    icon={
                      "https://q2pay.in/new_assets/common/view_all/close_with_blue_circle.svg"
                    }
                    enabledBgColor=""
                    outLineColor="var(--primary-act)"
                    disableIcon={false}
                    handleFunction={() => {
                      setAmountLimit({ min: "", max: "" });
                      setAmountLimitState({ min: "", max: "" });
                      setIsAmtFilterApplied(false);
                    }}
                    hoverOption="white"
                    enabledTextColor="var(--text-primary)"
                  />
                )}
                {source.length > 0 && (
                  <Chips
                    txtChip={source}
                    icon={
                      "https://q2pay.in/new_assets/common/view_all/close_with_blue_circle.svg"
                    }
                    enabledBgColor=""
                    outLineColor="var(--primary-act)"
                    disableIcon={false}
                    handleFunction={() => {
                      setSource("");
                      setSourceState("");
                    }}
                    hoverOption="white"
                    enabledTextColor="var(--text-primary)"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            position:
              showCalendar || filterOpen || showAdditionalDetails
                ? "absolute"
                : "relative",
            opacity:
              showCalendar || filterOpen || showAdditionalDetails
                ? "var(--dark-opacity)"
                : "var(--opcacity_none)",
            display:
              showCalendar || filterOpen || showAdditionalDetails
                ? "block"
                : "hidden",
            backgroundColor:
              showCalendar || showAdditionalDetails || filterOpen
                ? "var(--PopUp-BackDrop)"
                : "",
            height:
              showCalendar || filterOpen || showAdditionalDetails
                ? "var(--height-full)"
                : "0",
            width:
              showCalendar || filterOpen || showAdditionalDetails
                ? "var(--width-full)"
                : "0",
            zIndex: "var(--z-index-content)",
          }}
        ></div>

        <div
          ref={scrollRef}
          style={{
            backgroundColor: "var(--primary-bg)",
            overflowY: "hidden",
            overflowX:
              ownerAllAccStatementLoading ||
              !ownerAllAccStatementData?.statement?.length
                ? "hidden"
                : "scroll",
            marginBottom: ownerAllAccStatementData?.statement?.length
              ? "var(--pagination-height)"
              : "",
            borderRadius: "inherit",
            width:
              props?.popType == "ownerStatement" ||
              props?.popType === "remitterBankStatement"
                ? "var(--popup-width)"
                : "var(--full-width)",
          }}
          className={`${
            props?.popType == "ownerStatement" ||
            props?.popType === "remitterBankStatement"
              ? "popupstatementviewallscrolls"
              : ""
          }  overflow-x-auto flex flex-col statementviewallscroll flex-1`}
        >
          <div className="w-max min-w-full z-z-index-content ">
            <div
              className={`OAS-table-div-container ${
                showCalendar ? "" : selectStatement ? "" : " z-z-index-content"
              } mb-margin-xs pr-padding-sm`}
            >
              {additionalDetailCol?.map((column, index) => {
                return (
                  <>
                    <p
                      style={{
                        minWidth: `var(--${column.colWidth})`,
                        flex: `${column.flex}`,
                      }}
                      className={`text-font-xs px-padding-md h-auto break-all py-padding-button-l text-text-secondary text-center`}
                    >
                      {column.colName}
                    </p>
                    <div
                      style={{
                        display:
                          index === additionalDetailCol.length - 1
                            ? "none"
                            : "block",
                      }}
                      className="OAS-border-mid-div"
                    ></div>
                  </>
                );
              })}
            </div>
          </div>

          {!accountNumber.length ? (
            <div className="h-height-full flex-col m-auto pb-padding-md  overflow-y-scroll justify-center items-center flex w-full">
              <img
                src={
                  "https://q2pay.in/new_assets/graphics/general/view_category.svg"
                }
                alt="No accounts found"
                className="w-graphic-width-sm Qsmd:w-graphic-width-md  h-graphic-square-height-sm Qsmd:h-graphic-square-height-md"
              />
              <p className="text-font-sm text-text-primary flex flex-col pt-padding-sm">
                <span>
                  Select the account/s to view consolidated statement.
                </span>
              </p>
              <div className="pt-padding-sm">
                <PrimaryButton
                  enabledBgColor="var(--primary-act)"
                  btnText="Select account"
                  enabledTextColor="var(--text-primary)"
                  handleFunction={() => {
                    setShowOwnerPopup(true);
                  }}
                  buttonRef={selectAccountRef}
                  hoverOption="white"
                />
              </div>
            </div>
          ) : ownerAllAccStatementLoading ? (
            <div
              className={`absolute top-auto overflow-hidden flex h-height-lg m-auto justify-center items-center ${
                props?.popType === "ownerStatement"
                  ? "w-full-popup-width"
                  : "w-full-width"
              }`}
            >
              <img
                src={"https://q2pay.in/new_assets/gifs/inputloader_white.gif"}
                className="h-loader-lg w-loader-lg flex-shrink-0"
                alt=""
              />
            </div>
          ) : ownerAllAccStatementData?.statement?.length ? (
            <div
              ref={scrollTopRef}
              style={{
                flex: "1",
                overflowY:
                  ownerAllAccStatementLoading ||
                  ownerAllAccStatementData?.owner_account_details?.statement
                    ?.length
                    ? "hidden"
                    : "auto",
              }}
              className={` overflow-y-scroll w-max min-w-full  mt-margin-base`}
            >
              {ownerAllAccStatementData?.statement?.map((statement) => {
                return (
                  <div className="OAS-table-div-content mb-margin-xs">
                    {additionalDetailCol.some((x) => x.colName === "Bank") && (
                      <>
                        <div className="text-font-xs flex-0 pr-padding-md pl-padding-lg h-auto py-padding-xs  text-text-secondary text-center min-w-column-width-sm w-column-width-sm flex items-center">
                          <div className="py-padding-button-s px-padding-sm rounded-border-radius-md bg-text-primary flex justify-center items-center">
                            <div className="w-banklogo-width-sm h-banklogo-height-sm flex-shrink-0">
                              <IfscCodeMapper ifscCode={statement?.ifsc_code} />
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {additionalDetailCol.some(
                      (x) => x.colName === "Transaction date and time",
                    ) && (
                      <>
                        <p
                          className={
                            "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                          }
                        >
                          {formatDateandTime(
                            new Date(statement?.transaction_date),
                            true,
                          ) || "-"}
                        </p>
                      </>
                    )}
                    {additionalDetailCol.some(
                      (x) => x.colName === "Value date",
                    ) && (
                      <>
                        <p
                          className={
                            "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                          }
                        >
                          {formatDateandTime(new Date(statement?.value_date)) ||
                            "-"}
                        </p>
                      </>
                    )}

                    {additionalDetailCol.some(
                      (x) => x.colName === "Bank reference number",
                    ) && (
                      <>
                        <p
                          className={
                            "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-lg min-w-column-width-lg"
                          }
                        >
                          {statement?.bank_reference || "-"}
                        </p>
                      </>
                    )}
                    {additionalDetailCol.some(
                      (x) => x.colName === "Narration",
                    ) && (
                      <>
                        <p
                          className={
                            "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-1 text-text-primary text-center w-column-width-lg min-w-column-width-lg"
                          }
                        >
                          {linkIdentifier(statement?.narration) || "-"}
                        </p>
                      </>
                    )}
                    {additionalDetailCol.some((x) => x.colName === "Type") && (
                      <>
                        <div
                          className={
                            "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                          }
                        >
                          {statement?.credit_debit || "-"}
                        </div>
                      </>
                    )}
                    {additionalDetailCol.some(
                      (x) => x.colName === "Amount",
                    ) && (
                      <>
                        <div
                          className={
                            "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                          }
                          style={{
                            color: "var(--text-primary)",
                            textAlign: "right",
                            justifyContent: "end",
                          }}
                        >
                          INR <FormatAmount price={Number(statement?.amount)} />
                        </div>
                      </>
                    )}
                    {additionalDetailCol.some(
                      (x) => x.colName === "Debit amount",
                    ) && (
                      <>
                        <div
                          className={
                            "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                          }
                          style={{
                            color: "var(--failed)",
                            textAlign: "right",
                            justifyContent: "end",
                          }}
                        >
                          {statement.credit_debit == "Debit" ? (
                            <>
                              INR{" "}
                              <FormatAmount price={Number(statement?.amount)} />
                            </>
                          ) : (
                            "-"
                          )}
                        </div>
                      </>
                    )}
                    {additionalDetailCol.some(
                      (x) => x.colName === "Credit amount",
                    ) && (
                      <>
                        <div
                          className={
                            "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                          }
                          style={{
                            color: "var(--settled)",
                            textAlign: "right",
                            justifyContent: "end",
                          }}
                        >
                          {statement.credit_debit == "Credit" ? (
                            <>
                              INR{" "}
                              <FormatAmount price={Number(statement?.amount)} />
                            </>
                          ) : (
                            "-"
                          )}
                        </div>
                      </>
                    )}

                    {additionalDetailCol.some(
                      (x) => x.colName === "Closing balance",
                    ) && (
                      <>
                        <p
                          style={{ justifyContent: "end" }}
                          className={
                            "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                          }
                        >
                          INR{" "}
                          <FormatAmount
                            price={Number(statement?.closing_balance)}
                          />
                        </p>
                      </>
                    )}

                    {additionalDetailCol.some(
                      (x) => x.colName === "Account number",
                    ) && (
                      <>
                        <p
                          onClick={() => {
                            if (props?.popType != "ownerStatement") {
                              setOwnerDetailID(statement.owner_account_id);
                              setTimeout(() => {
                                setShowOwnerDetailPopup(true);
                              }, 500);
                            }
                          }}
                          className={`text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md ${
                            props?.popType != "ownerStatement"
                              ? "ownerredirect"
                              : ""
                          } `}
                        >
                          {formatAccountNumber(
                            statement?.owner_bank_account_number,
                          ) || "-"}
                        </p>
                      </>
                    )}
                    {additionalDetailCol.some(
                      (x) => x.colName === "IFSC code",
                    ) && (
                      <>
                        <p
                          className={
                            "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                          }
                        >
                          {statement?.ifsc_code || "-"}
                        </p>
                      </>
                    )}

                    {additionalDetailCol.some(
                      (x) => x.colName === "Statement source",
                    ) && (
                      <p
                        className={
                          "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                        }
                      >
                        {statement?.uploaded
                          ? "Uploaded manually"
                          : "Fetched from bank"}
                      </p>
                    )}
                    {additionalDetailCol.some(
                      (x) => x.colName === "Description",
                    ) && (
                      <div
                        className={
                          " px-padding-md h-auto flex items-center justify-center py-padding-xs flex-1 text-text-primary text-center w-column-width-lg min-w-column-width-lg"
                        }
                      >
                        {statement?.description?.length ? (
                          <div className="flex gap-x-gap-sm justify-center">
                            <p className="text-font-xs text-text-secondary break-all">
                              {linkIdentifier(statement?.description)}
                            </p>
                            <div className="border-r-border h-auto border-primary-act"></div>
                            <img
                              title="Edit"
                              src="https://q2pay.in/new_assets/common/create_flow/edit.svg"
                              alt="edit"
                              className={`h-icon-sm w-icon-sm flex-shrink-0 my-auto ${
                                !services?.includes("ADescription") &&
                                !services?.includes("Admin")
                                  ? "cursor-not-allowed opacity-light-opacity"
                                  : "cursor-pointer"
                              } `}
                              onClick={() => {
                                if (
                                  !services?.includes("ADescription") &&
                                  !services?.includes("Admin")
                                ) {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService:
                                        "VAccountBalance,Admin",
                                    },
                                  });
                                } else {
                                  setIsEditDescription(true);
                                  setDescription(statement?.description);
                                  setCurrentDescription({
                                    acc_id: statement?.owner_account_id,

                                    description: statement?.description,
                                    account_statement_entry_id:
                                      statement?.account_statement_entry_id,
                                  });
                                  setShowDescriptionPopup(true);
                                }
                              }}
                            />
                          </div>
                        ) : (
                          <PrimaryWithIconButton
                            btnText="Add description"
                            outLineColor={"var(--text-primary)"}
                            btnType="button"
                            enabledBgColor="transparent"
                            enabledTextColor="var(--text-primary)"
                            hoverOption="white"
                            iconToBeAlign="left"
                            icon="https://q2pay.in/new_assets/common/settings/add_button_white.svg"
                            imgColor="var(--text-primary)"
                            isDisabled={
                              !services?.includes("ADescription") &&
                              !services?.includes("Admin")
                            }
                            handleFunction={() => {
                              if (
                                !services?.includes("ADescription") &&
                                !services?.includes("Admin")
                              ) {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "VAccountBalance,Admin",
                                  },
                                });
                              } else {
                                setShowDescriptionPopup(true);
                                setCurrentDescription({
                                  acc_id: statement?.owner_account_id,

                                  description: statement?.description,
                                  account_statement_entry_id:
                                    statement?.account_statement_entry_id,
                                });
                              }
                            }}
                          />
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : (
            <div
              className={`flex-1 flex-col m-auto  ${
                props?.popType === "ownerStatement"
                  ? "w-full-popup-width"
                  : "w-full-width"
              } ${ownerAllAccStatementData?.statement?.length ? "pb-padding-xl" : "pb-padding-base"}  overflow-y-scroll justify-center items-center flex`}
            >
              <img
                src={
                  "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                }
                alt="No accounts found"
                className="w-graphic-width-lg h-graphic-rectangle-height-lg "
              />
              <p className="text-text-primary text-font-sm pt-padding-sm items-center">
                No data found.
              </p>
              <div
                style={{
                  display:
                    accountNumber.length !== accountDefaultNumber.length ||
                    !accountDefaultNumber.every((ac) => {
                      return accountNumber.includes(ac);
                    }) ||
                    (new Date(startDate).setHours(0, 0, 0, 0) !==
                      new Date(new Date().setDate(1)).setHours(0, 0, 0, 0) &&
                      new Date(endDate).setHours(0, 0, 0, 0) !==
                        new Date().setHours(0, 0, 0, 0)) ||
                    selectedtBank.length ||
                    statementType.length ||
                    (amountLimit.min.length && amountLimit.max.length)
                      ? "flex"
                      : "none",
                  paddingTop: "var(--padding-sm)",
                }}
              >
                <PrimaryButton
                  isDisabled={
                    filterOpen || showAdditionalDetails || showCalendar
                  }
                  enabledBgColor="var(--primary-act)"
                  btnText="Clear parameters"
                  enabledTextColor="var(--text-primary)"
                  handleFunction={() => {
                    move();
                    setAccountNumber(accountDefaultNumber);
                    setaccountnumberstate(accountDefaultNumber);
                    setSelectedtBank("");
                    setSelectedtBankState("");
                    setAmountLimit({ min: "", max: "" });
                    setAmountLimitState({ min: "", max: "" });
                    setStatementType("");
                    setStatementTypeState("");
                    setIsAmtFilterApplied(false);
                    setStartDate(new Date(new Date().setDate(1)));
                    setStartDateState(new Date(new Date().setDate(1)));
                    setEndDate(new Date());
                    setEndDateState(new Date());
                    setIsDateConfirm(false);
                    setCurrentPage(1);
                  }}
                  buttonRef={selectAccountRef}
                  hoverOption="white"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default OwnerAllStatement;
